import React from "react";
import { SubInfoPage } from "./components/account/SubInfoPage";

const PricingPage = () => {
  return (
    <div className="p-6 pt-32 pb-14 relative overflow-x-hidden">
      <div className="w-[530px] h-[530px] absolute top-[70%] left-[50%] translate-x-[-50%] translate-y-[-50%] bg-[#AFFFFE] rounded-full blur-[250px] z-[-1]" />

      <SubInfoPage
        className="!bg-transparent"
        classNameContent={"!gap-1"}
        isLanding
      />
    </div>
  );
};

export default PricingPage;
